module.exports = __webpack_public_path__ + "static/media/document-duplicate.9c9a75ac.svg";